import { render } from "./related.vue?vue&type=template&id=64199238"
import script from "./related.vue?vue&type=script&lang=js"
export * from "./related.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
var __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__